export const ResultCodeEnum={
    Ok : 0,

    Ip_Unauthorized : 11,
    Ip_Blocked : 12,

    Domain_Invalid : 21,
    Domain_NotExist : 22,
    Domain_InActive : 23,
    Domain_MaxSession : 24,
    Domain_Expired : 25,

    Agent_Invalid : 31,
    Agent_NotExist : 32,
    Agent_InActive : 33,
    Agent_MaxSession : 34,
    Agent_Expired : 35,

    Username_UEmpty : 41,
    Username_PEmpty : 42,
    Username_NotExist : 43,
    Username_SafeMode : 44,
    Username_Password : 45,
    Username_InActive : 46,
    Username_Time : 47,
    Username_Date : 48,

    Group_NotExist : 51,
    Group_InActive : 52,
    Group_SafeMode : 53,
    Group_Time : 54,
    Group_Date : 55,

    Policy_MaxSession : 61,
    Policy_Os : 62,
    Policy_Ip : 63,
    Policy_Browser : 64,
    Policy_Location : 65,

    Token_Empty : 71,
    Token_Type : 72,
    Token_Unauthorized : 73,
    Token_Expired : 74,

    Unauthorized_Os : 81,
    Unauthorized_Ip : 82,
    Unauthorized_Browser : 83,
    Unauthorized_Location : 84,
    Unauthorized_Access : 85,
    Unauthorized_Column : 86,
    Unauthorized_Record : 87,

    Invalid_Input : 91,
    Invalid_Filter : 92,
    Invalid_SelectedId : 93,
    Invalid_Content : 94,
    Invalid_Duplicate : 95,
    Invalid_Socket : 96,

    Recognition_Empty : 101,
    Recognition_Quality : 102,
    Recognition_NotIdentified : 103,
    Recognition_Smile : 104,

    SafeMode_Main : 111,
    SafeMode_NotAuthorized : 112,
    SafeMode_Inactive : 113,

    Record_Undefined : 121,
    Record_NotAuthorized : 122,
    Record_NotFound : 123,
    Record_Dependence : 124,
    Record_Belongings : 125,
    Record_Status : 126,
    Record_Completed : 127,

    Url_Empty : 131,
    Url_Invalid : 132,
    Url_IsCompleted : 133,
    Url_Expire : 134,

    Setting_Undefined : 141,
    Setting_Empty : 142,
    Setting_Inactive : 143,
    Setting_Invalid : 144,
    Setting_Incompatibility : 145,
    Setting_Size : 146,

    Failed_Create : 151,
    Failed_Read : 152,
    Failed_Update : 153,
    Failed_Delete : 154,
    Failed_SendSms : 155,


    Unknown : 1000
}

